import { ImageCarousel } from '@/components/ui/images/image-carousel/ImageCarousel';

export const CarouselImageItem = ({ data }) => {
  const imagePrefix = '';

  return (
    <ImageCarousel
      src={imagePrefix + data?.fields?.carousel_img}
      alt={data?.fields?.alt_img}
      sizes={{
        width: data?.fields?.sizes?.width || 461,
        height: data?.fields?.sizes?.height || 461,
      }}
    />
  );
};
